/* eslint func-style: "off" */
import { all, fork, takeLatest, call, put, select } from 'redux-saga/effects';
import * as actions from './TrendingStoriesOverview.slice';
import apiClient from '../../helpers/apiClient';

// Since the calls are made in paralell and we have only one catch block for all
// errors we need a way to identify each independent error
const loadOverview = function*({ profileId, searched_link, startTime, endTime }) {
  try {
    const detailOptions = {
      method: 'POST',
      body: JSON.stringify({ profileIds: [profileId], link: searched_link, startTime, endTime })
    };
    const storyDetails = yield call(apiClient, '/api/analytics/trending-stories-overview', detailOptions);

    yield put(actions.setStoryDetails(storyDetails));
  } catch (e) {
    yield put(actions.loadOverviewError(e));
  }
};

const loadAnalytics = function*({ story_id, link_index, created_at, profileId }) {
  try {
    const fetchOptions = {
      method: 'POST',
      body: JSON.stringify({ story_id, link_index, created_at, profileId })
    };
    const analytics = yield call(apiClient, '/api/analytics/trending-stories-analytics', fetchOptions);
    yield put(actions.setAnalytics(analytics));
  } catch (e) {
    yield put(actions.loadAnalyticsError(e));
  }
};

const getState = (state) => state.TrendingStoriesOverview;

const fetchTweets = function*() {
  try {
    const { story: { link }, profileId, startTime, endTime } = yield select(getState);
    const body = {
      profileIds: [profileId],
      link,
      startTime,
      endTime
    };
    const fetchOptions = {
      method: 'POST',
      body: JSON.stringify(body)
    };
    const tweets = yield call(apiClient, '/api/stories/trending-stories-mentions', fetchOptions);
    yield put(actions.setTweets(tweets));
  } catch (e) {
    yield put(actions.loadTweetsError(e));
  }
};

// The call for this happens when the user selects a story in the trending stories widget
// Two things need to be done:
// 1. Fetch the story statistics from the external service
// 2. Fetch the story mentions chart data along with the first mention
const fetchStoryData = function*({
  payload: {
    story: { story_id, link_index, created_at, searched_link }, profileId, startTime, endTime
  }
}) {

  yield all([
    call(loadOverview, { profileId, searched_link, startTime, endTime }),
    call(loadAnalytics, { story_id, link_index, created_at, profileId, startTime, endTime })
  ]);
};

const fetchStoryDataSaga = function* () {
  yield takeLatest(actions.handleOpen.type, fetchStoryData);
};

const fetchTweetsSaga = function* () {
  yield takeLatest(actions.loadTweets.type, fetchTweets);
};

const sagas = function*() {
  yield all([
    fork(fetchStoryDataSaga),
    fork(fetchTweetsSaga),
  ]);
};

export default sagas;

export {
  loadOverview,
  loadAnalytics,
  fetchTweets,
  getState,
  fetchStoryDataSaga,
  fetchTweetsSaga,
  fetchStoryData
};
